import React, { useEffect, useState} from "react";
import { createPortal } from 'react-dom';
import moment from 'moment';
import store from "@/redux/store";

import { Switch, Field } from '@headlessui/react'
import {SelectBox} from '@/components/holders/SelectBox'
import {FieldHolder} from "@/components/holders/FieldHolder";

export function DossierSelect({...props}) {
    
    const items = store.getState().AuthReducer.dossiers;
    let selectedDossier = null;
    if(props?.selected != "") {
        selectedDossier = items.findChildByKey(props?.selected, 'key');
        
    }

    let selectedDossierTask = null;
    if(props?.selectedTask != "") {
        selectedDossierTask = items.findChildByKey(props?.selectedTask, 'key');
        
    }
    
    const [selected, setSelected] = useState();
    const [selectedTask, setSelectedTask] = useState();
    const [filter, setFilter] = useState({name: ''});
    
    useEffect(() => {
        
        if(selectedDossier) {
            setSelected(selectedDossier);
        }
        if(selectedDossierTask) {
            setSelectedTask(selectedDossierTask);
        }
    
        return () => {
            
        };
    }, [selectedDossier, selectedDossierTask]);

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

    const changeEventOnTask =((name, selected) => {
        if(selected) {
            setSelectedTask(selected);
            if(props.onChangeEvent) {
                props.onChangeEvent(name, selected);
            }
        }
        });
    
    const changeEventOnCustomer =((name, selected) => {
        if(selected) {
            setSelected(selected);
            setSelectedTask(props?.emptyOptionTask);
            if(props.onChangeEvent) {
                props.onChangeEvent(name, selected);
            }
        }
        });
    const createTaskSelector = (selected) => {
        if(!selected || (!selected?.key)) {
            return ;            
        }
        return (
            <FieldHolder key={selected.key} colspan="12" smcolspan="12" label={"Hoofdtaak"} id="task" error={props?.state?.error}>
                <SelectBox className="" name="task" data={selected?.simple_children.wherenot('state', 9).get()} boxfield="name" boxfieldSub="" changeEvent={changeEventOnTask} selected={selectedTask} emptyOption={props?.emptyOptionTask}/>
            </FieldHolder>
            );
    }

    return (<>
    <FieldHolder colspan="12" smcolspan="12" label={"Dossier"} id="name" error={props?.state?.error}>
        <SelectBox className="" name="dossier" data={items.get()} boxfield="name" boxfieldSub="" changeEvent={changeEventOnCustomer} selected={selected} emptyOption={props?.emptyOption}/>
    </FieldHolder>

        {createTaskSelector(selected)} 
    
    </>)

}
    